var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import { useReducer } from 'react';
import { useSelector } from 'react-redux';
import logger from 'use-reducer-logger';
import { SalesforceServiceFacade } from '@/services/salesforce-service-facade.service';
var initialState = {
    status: 'idle',
};
var reducer = function (state, action) {
    switch (action.type) {
        case 'SEND_DATA':
            return __assign(__assign({}, state), { status: 'loading' });
        case 'SEND_DATA_SUCCESS':
            return __assign(__assign({}, state), { status: 'success', error: null });
        case 'SEND_DATA_FAILURE':
            return __assign(__assign({}, state), { status: 'error', error: action.error });
        default:
            return state;
    }
};
var facade = new SalesforceServiceFacade();
export var useSalesforceService = function (_a) {
    var _b = _a === void 0 ? {} : _a, _c = _b.debug, debug = _c === void 0 ? false : _c;
    var rootState = useSelector(function (state) { return state; });
    var _d = useReducer(debug ? logger(reducer) : reducer, initialState), state = _d[0], dispatch = _d[1];
    var send = function (fn) { return __awaiter(void 0, void 0, void 0, function () {
        var error_1;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    dispatch({ type: 'SEND_DATA' });
                    _a.label = 1;
                case 1:
                    _a.trys.push([1, 3, , 4]);
                    return [4 /*yield*/, fn()];
                case 2:
                    _a.sent();
                    dispatch({ type: 'SEND_DATA_SUCCESS' });
                    return [2 /*return*/];
                case 3:
                    error_1 = _a.sent();
                    console.error(error_1);
                    dispatch({ type: 'SEND_DATA_FAILURE', error: error_1 });
                    return [2 /*return*/];
                case 4: return [2 /*return*/];
            }
        });
    }); };
    var sendTestCompleted = function () { return __awaiter(void 0, void 0, void 0, function () {
        return __generator(this, function (_a) {
            send(function () { return facade.sendTestCompleted(rootState); });
            return [2 /*return*/];
        });
    }); };
    var sendVideoCallCompleted = function () { return __awaiter(void 0, void 0, void 0, function () {
        return __generator(this, function (_a) {
            send(function () { return facade.sendVideoCallCompleted(rootState); });
            return [2 /*return*/];
        });
    }); };
    var sendCallbackRequested = function () { return __awaiter(void 0, void 0, void 0, function () {
        return __generator(this, function (_a) {
            send(function () { return facade.sendCallbackRequested(rootState); });
            return [2 /*return*/];
        });
    }); };
    return {
        isIdle: state.status === 'idle',
        isLoading: state.status === 'loading',
        isSuccess: state.status === 'success',
        isError: state.status === 'error',
        error: state.error,
        sendTestCompleted: sendTestCompleted,
        sendVideoCallCompleted: sendVideoCallCompleted,
        sendCallbackRequested: sendCallbackRequested,
    };
};
